import { loadScript } from './tools';

const selector = '[data-etrusted-widget-id]';
const script = 'https://integrations.etrusted.com/applications/widget.js/v2';

const el = document.querySelector(selector);

if (el) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            loadScript(script);
            observer.unobserve(el);
        }
    });

    observer.observe(el);
}
